import React, { useEffect, useState } from "react";
// react-bootstrap components
import { Card, Form, Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { apiService } from "../../../service/ApiService";
import { notificationService } from "../../../service/NotificationService";
import CreateButton from "components/Buttons/CreateButton";
import EditButton from "components/Buttons/EditButton";
import GeneralStoreSelect from "components/DropDowns/GeneralStoreSelect";
import TableRegionSelect from "components/DropDowns/TableRegionSelect";

import { useTranslation } from "react-i18next";

function TablePage() {
  const {
    t,
  } = useTranslation();

  const backRoute = "/admin/tables";
  const history = useHistory();
  const { id } = useParams();
  const [storeId, setStoreId] = useState(null);
  const [tableName, setTableName] = useState("");
  const [tableColor, setTableColor] = useState("#28c76f");
  const [tableOrder, setTableOrder] = useState(0);
  const [tableRegionId, setTableRegionId] = useState(null);
  const [tableDeleted, setTableDeleted] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const handleStoreId = (id) => {
    setStoreId(id);
  };

  const handleScroll = (e) => {
    e.target.blur();
  };

  useEffect(() => {
    if (!id) return;
    apiService
      .get(`api/v1/tables/${id}`)
      .then((table) => {
        fillFields(table);
      })
      .catch((error) => {
        notificationService.notifyError(error.message);
        history.push(backRoute);
      });
  }, []);

  const handleRegionChange = (regionId) => {
    setTableRegionId(regionId);
  };

  const save = () => {
    setIsDisabled(true);
    const table = {
      name: tableName,
      color: tableColor ? tableColor : "ffffff",
      order: tableOrder ? tableOrder : 0,
      storeId: storeId,
      regionId: tableRegionId,
      deleted: tableDeleted,
    };

    if (id) {
      apiService
        .putJson(`api/v1/tables/${id}`, table)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.tableSavedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    } else {
      apiService
        .postJson("api/v1/tables", table)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.tableCreatedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    }
  };

  const fillFields = (table) => {
    setTableName(table.name);
    setTableColor(table.color);
    setTableOrder(table.order);
    setTableDeleted(table.deleted);
    setTableRegionId(table.region.id);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="stacked-form">
              <Card.Header>
                <Card.Title as="h4">{id ? t("pages.titles.editTable") : t("pages.titles.createTable")}</Card.Title>
              </Card.Header>
              <Card.Body>
                {errorMessage ? <div style={{ color: "crimson" }}>{errorMessage}</div> : null}
                <Form action="#" method="#">
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>{t("common.labels.designation")}</label>
                        <Form.Control
                          placeholder={t("common.labels.designation")}
                          required={true}
                          type="text"
                          value={tableName}
                          onChange={(event) => setTableName(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.color")}</label>
                        <Form.Control
                          placeholder={t("common.labels.color")}
                          required={true}
                          type="color"
                          value={tableColor}
                          onChange={(event) => setTableColor(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.order")}</label>
                        <Form.Control
                          placeholder={t("common.labels.order")}
                          required={true}
                          type="number"
                          value={tableOrder}
                          onChange={(event) => setTableOrder(event.target.value)}
                          min="0"
                          onWheel={handleScroll}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <GeneralStoreSelect title={t("common.labels.store")} disabled={true} selectedStoreId={handleStoreId} />
                    </Col>
                    <Col>
                      <TableRegionSelect defaultValue={tableRegionId} handler={handleRegionChange} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="2">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-2" checked={tableDeleted} onChange={(e) => setTableDeleted(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.inactive")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
                <Row className="float-right">
                  <Col>{id ? <EditButton handler={save} disabled={isDisabled} /> : <CreateButton handler={save} disabled={isDisabled} />}</Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default TablePage;
